// ==========================================
// NOBISHIRO - 40法則データベース（完全版）
// ==========================================
// 
// 各法則の構成:
// - name: 法則名
// - description: 基本説明（短い）
// - simpleDescription: 身近な例えを使った分かりやすい説明
// - trizOrigin: TRIZ原理との関連
// - psychologyOrigin: 心理学理論との関連
//
// ==========================================

export const developmentLaws = {
  // ==========================================
  // Law 01-02: 基本情報のみ（詳細解説は追加予定）
  // ==========================================

  'law01': {
    name: '複合思考統合',
    description: '複雑な組織課題を多角的に分析・統合する力。',
    simpleDescription: '複数の視点から物事を見て、バラバラの情報を一つにまとめる力。料理で例えると、様々な食材の特性を理解し、それぞれの良さを活かしながら一つの料理として完成させる。パズルのピースを集めて全体像を描く思考法です。',
    trizOrigin: '第1原理: 分割 / 第5原理: 統合 - 複雑な問題を分割して分析し、解決策を統合する。',
    psychologyOrigin: 'システム思考と統合的認知発達理論。複数の情報源から統合的な理解を構築する高次認知能力。'
  },

  'law02': {
    name: '段階的深化',
    description: '表面的な理解から本質的な理解へと段階的に深める力。',
    simpleDescription: '最初は「なんとなくわかる」から始めて、だんだん「本当にわかる」へと理解を深める力。泳ぎを覚えるとき、最初はバタ足から始めて、だんだん綺麗なフォームになっていくように、知識も技術も段階的に深めていく学習法です。',
    trizOrigin: '第17原理: 次元移動 / 第19原理: 周期的作用 - 一次元の理解から多次元の深い理解へ、周期的な学習を通じて深化させる。',
    psychologyOrigin: 'ブルームの認知的領域タキソノミーと深い学習理論。記憶→理解→応用→分析→評価→創造への段階的発達。'
  },

  // ==========================================
  // Law 03-40: 完全データ
  // ==========================================

  'law03': {
    name: 'システム思考発達',
    description: '部分最適から全体最適へと思考を転換する力。',
    simpleDescription: '森を見て木を見ず、木を見て森を見ず、ではなく「森も木も両方見る」力。部署の利益だけ考えるのではなく、会社全体にとって最善の判断ができる視点。パズルの一つのピースだけでなく、完成形全体を想像しながら取り組む思考法です。',
    trizOrigin: '第3原理: 局所的品質 / 第28原理: システム代替 - 部分的改善から全体システムの最適化へと発想を転換する考え方。',
    psychologyOrigin: 'システム理論とブロンフェンブレナーの生態学的システム理論。個人を取り巻く複数のシステム（家族、学校、職場、社会）の相互作用を理解する発達観。'
  },

  'law04': {
    name: '抽象化能力',
    description: '具体的な経験から普遍的な原則を抽出する力。',
    simpleDescription: '具体的な経験から「なるほど、つまりこういうことか！」という法則やコツを見つけ出す力。料理を何度も作るうちに「火加減はこのタイミングで」という勘所を掴むように、経験を一段階上の知恵に昇華させる能力です。',
    trizOrigin: '第17原理: 次元移動 - 具体的な一次元の問題を、より抽象的で汎用的な高次元の解決原理へと移行させる。',
    psychologyOrigin: 'ピアジェの認知発達理論における「形式的操作期」の抽象的思考能力と、ブルーナーの「概念学習理論」における具体から抽象への思考の発達。'
  },

  'law05': {
    name: '創造的問題解決',
    description: '既存の枠を超えた革新的解決策を生み出す力。',
    simpleDescription: '「今までになかった新しいもの」を生み出す力。既存のアイデアを組み合わせて、誰も思いつかなかった解決策を発見する。レゴブロックで説明書にない独創的な作品を作るような、創造的な問題解決能力です。',
    trizOrigin: '第2原理: 分離 / 第15原理: ダイナミック化 - 固定的な従来手法から革新的で動的なアプローチへの分離と転換。',
    psychologyOrigin: 'ギルフォードの「拡散的思考」と「収束的思考」の統合、およびアメイビルの創造性の構成要素理論（専門知識、創造的思考スキル、内発的動機の組み合わせ）。'
  },

  'law06': {
    name: '論理・直感統合',
    description: '分析的思考と直感的洞察を統合する力。',
    simpleDescription: '頭で考える論理と、心で感じる直感の両方を使いこなす力。データ分析の結果と「なんとなく感じる違和感」の両方を大切にして、より良い判断を下す。名探偵が論理的推理と鋭い直感を組み合わせて真相に辿り着くイメージです。',
    trizOrigin: '第8原理: つり合い / 第33原理: 均質性 - 異なる性質の要素（論理と直観）をバランス良く統合し、より高次の判断力を実現する。',
    psychologyOrigin: 'カーネマンの「システム1（直感的・自動的思考）とシステム2（論理的・統制的思考）」の統合理論、および右脳・左脳の機能統合に関する神経心理学的知見。'
  },

  'law07': {
    name: '継続的学習',
    description: '環境変化に応じて学び続ける適応力。',
    simpleDescription: '変化する時代に合わせて、自分のスキルをアップデートし続ける力。スマホアプリが定期的に新機能を追加するように、新しい環境や技術に応じて自分自身を「バージョンアップ」していく学習姿勢です。',
    trizOrigin: '第15原理: ダイナミック化 / 第35原理: パラメータ変更 - 固定的な能力から、環境変化に応じて動的に調整可能な適応的能力への転換。',
    psychologyOrigin: 'バンデューラの社会認知理論における「自己調整学習」と、ドゥエックの「成長マインドセット」。能力は固定的ではなく開発可能という信念に基づく継続学習。'
  },

  'law08': {
    name: 'メタ認知発達',
    description: '自己の思考過程を客観視し改善する力。',
    simpleDescription: '自分の考え方の「クセ」や「思考のパターン」を客観的に見つめる力。「あ、私っていつもこういう風に考えがちだな」と気づき、より良い思考方法に修正していく。自分の頭の中にもう一人の自分がいて、冷静にアドバイスしてくれるイメージです。',
    trizOrigin: '第23原理: フィードバック / 第32原理: 色を変える - 自己の思考過程を可視化し、改善のためのフィードバックループを構築する。',
    psychologyOrigin: 'フラベルが提唱した「メタ認知」概念と、ブラウンの「メタ認知的知識・経験・方略」の三要素モデル。自己の認知過程を認知し調整する高次認知能力。'
  },

  'law09': {
    name: '視点転換能力',
    description: '固定観念を超えて多角的視点を獲得する力。',
    simpleDescription: '「いつものやり方」にとらわれずに、新しい視点で物事を見る力。同じ問題でも角度を変えて眺めると、全く違う解決策が見えてくる。万華鏡を回すと同じガラス片でも全く違う美しい模様が現れるように、思考の角度を変える柔軟性です。',
    trizOrigin: '第13原理: 逆発想 / 第24原理: 仲介 - 固定的な思考パターンを逆転させ、異なる視点を仲介として活用する認知的柔軟性。',
    psychologyOrigin: 'ギルフォードの「知能の構造モデル」における認知的柔軟性と、実行機能研究における「認知的制御」および「セット・シフティング」能力。'
  },

  'law10': {
    name: '知識の実践化',
    description: '理論を実務に適用する応用力。',
    simpleDescription: '学んだことを「机上の空論」で終わらせず、実際の場面で使いこなす力。英語の文法を覚えただけでなく、実際に外国人と会話できるようになる。知識を「生きた智恵」に変換する実践的応用能力です。',
    trizOrigin: '第20原理: 連続性の維持 / 第27原理: 安価な代替物 - 学習した知識を実務場面で連続的に活用し、コスト効率の良い問題解決を実現する。',
    psychologyOrigin: '学習の転移理論（ソーンダイクの同一要素説からより現代的な文脈依存学習まで）と、コルブの「経験学習理論」における実践への応用プロセス。'
  },

  'law11': {
    name: '関係性拡張',
    description: '対人関係を深め広げる力。',
    simpleDescription: '人間関係を「点」から「面」、そして「立体」へと広げていく力。最初は一対一の関係から始まり、チーム、部署、会社全体へと影響の輪を拡大していく。小さな石を池に投げると波紋が広がるように、人とのつながりを段階的に発展させる能力です。',
    trizOrigin: '第7原理: 入れ子 / 第17原理: 次元移動 - 個人的関係という「入れ子」から、より大きな組織的・社会的関係へと次元を移動させる。',
    psychologyOrigin: 'ボウルビィの愛着理論の発達的展開と、社会的ネットワーク理論。初期の安全な愛着関係が、より広範囲な社会的関係形成の基盤となる発達過程。'
  },

  'law12': {
    name: '協働意識',
    description: '競争から協調へと意識を転換する力。',
    simpleDescription: '「勝ち負け」の競争から「一緒に創る」協力へと意識を変える力。ライバルを蹴落とすのではなく、お互いの強みを活かして、一人では達成できない大きな成果を生み出す。オーケストラの演奏者が他の楽器の音に耳を澄ませながら美しいハーモニーを奏でる協働精神です。',
    trizOrigin: '第5原理: 統合 / 第25原理: セルフサービス - 競争する要素を統合し、相互に価値を提供し合う協働的システムを構築する。',
    psychologyOrigin: 'モートン・ドイッチュの協力・競争理論と、現代の社会的相互依存理論。共通の目標達成における協働の心理的・社会的メカニズム。'
  },

  'law13': {
    name: '共感的理解',
    description: '他者の視点から物事を理解する力。',
    simpleDescription: '相手の立場に立って、その人の気持ちや状況を本当に理解する力。「もし自分だったら」という想像力で、違う価値観や背景を持つ人とも心を通わせる。映画を見るとき、主人公だけでなくすべての登場人物の視点で物語を理解できるような、多角的共感能力です。',
    trizOrigin: '第24原理: 仲介 / 第14原理: 曲面化 - 自分と他者の間に共感という仲介を置き、直線的でない柔軟な理解のアプローチを実現する。',
    psychologyOrigin: 'プリマックとウッドラフの「心の理論」発達研究と、ホフマンの共感性発達理論。他者の心的状態を理解し、情動的に共鳴する能力の発達過程。'
  },

  'law14': {
    name: 'コミュニケーション深化',
    description: '言語・非言語を統合した高度な意思疎通力。',
    simpleDescription: '言葉だけでなく、表情、声のトーン、身振りなど、あらゆる手段を使って相手に思いを伝える力。同時に、相手が本当に言いたいことを言葉以外からも読み取る。会話を「言葉のキャッチボール」から「心のキャッチボール」に進化させる総合的コミュニケーション能力です。',
    trizOrigin: '第29原理: 流体・気体の利用 / 第36原理: 相転移 - 固体的な言語コミュニケーションから、より流動的で多様な表現形態への転移を実現する。',
    psychologyOrigin: 'メラビアンの「7-38-55ルール」（言語・音調・身体言語の影響比率）と、語用論的コミュニケーション理論における文脈的意味理解の発達。'
  },

  'law15': {
    name: '社会的責任感',
    description: '個人を超えた社会への責任意識。',
    simpleDescription: '「自分さえ良ければ」から「みんなで良くなろう」へと責任感を拡大する力。家族、職場、地域、社会と、だんだん大きな枠組みで物事を考えられるようになる。自分の行動が周りにどんな影響を与えるかを意識し、より良い社会作りに貢献する当事者意識です。',
    trizOrigin: '第10原理: 先取り作用 / 第34原理: 廃棄と再生 - 個人的利益の追求から、社会的責任の先取り的実行へと発想を転換し、社会システムの持続的再生に貢献する。',
    psychologyOrigin: 'コールバーグの道徳発達段階理論（特に慣習以後レベル）と、エリクソンの世代継承性概念。個人的道徳から普遍的倫理への発達過程。'
  },

  'law16': {
    name: '文化的適応',
    description: '多様な文化環境に適応する力。',
    simpleDescription: '新しい環境や文化に飛び込んだ時、その場の「空気」や「やり方」を素早く理解し、自然に溶け込む力。海外旅行先で現地の習慣に敬意を払いながら楽しむように、異なる組織文化にも柔軟に適応し、その文化の良さを活かしながら貢献する能力です。',
    trizOrigin: '第30原理: 柔軟な膜・薄膜 / 第16原理: 過不足（少しだけ） - 自分と環境の境界を柔軟にし、適切な程度で文化的要素を取り入れる適応的調整。',
    psychologyOrigin: 'ベリーの異文化適応理論における「統合型適応」と、文化心理学における文化的自己と個人的自己の調整メカニズム。'
  },

  'law17': {
    name: '集団アイデンティティ',
    description: '個と集団の調和を図る力。',
    simpleDescription: '「みんな同じ」でもなく「バラバラ」でもない、ちょうど良いチームワークを作る力。それぞれの個性や得意分野を活かしながら、共通の目標に向かって一体感を保つ。ジャズバンドのように、各楽器の個性を活かしつつ美しいハーモニーを奏でる調和の技術です。',
    trizOrigin: '第8原理: つり合い / 第33原理: 均質性 - 多様性と統一性のバランスを保ち、個別性を維持しながら全体的な調和を実現する。',
    psychologyOrigin: 'タジフェルの社会的アイデンティティ理論と、ターナーの自己カテゴリー化理論。個人のアイデンティティと集団への所属意識の両立メカニズム。'
  },

  'law18': {
    name: '変革的リーダーシップ',
    description: '人を動かし変革を導く影響力。',
    simpleDescription: '「偉いから従え」ではなく「一緒に良くしよう」という姿勢で人を動かす力。命令ではなく、自分の行動や考え方で周りの人にポジティブな影響を与える。灯台のように、自ら光を放って船を安全に導くような、人格的影響力によるリーダーシップです。',
    trizOrigin: '第9原理: 先取り反作用 / 第22原理: 災い転じて福となす - 問題を先取りして解決し、困難な状況も成長の機会に変える変革的アプローチ。',
    psychologyOrigin: 'バスとアボリオの変革的リーダーシップ理論と、バンデューラの社会認知理論におけるモデリング効果。権威ではなく影響力による指導の心理的メカニズム。'
  },

  'law19': {
    name: '協創的学習',
    description: '他者と共に新しい知識を創造する力。',
    simpleDescription: '「教える・学ぶ」を超えて、みんなで一緒に新しい知識や解決策を生み出す力。会議でも、一方的に話すのではなく、参加者全員の知恵を引き出し組み合わせて、誰も思いつかなかった良いアイデアを創造する。料理番組でシェフと視聴者が一緒に新レシピを開発するような協創的学習です。',
    trizOrigin: '第26原理: コピー / 第35原理: パラメータ変更 - 単純な知識のコピーから、参加者それぞれの視点を活かしたパラメータ変更による新しい知識創造へ。',
    psychologyOrigin: 'ヴィゴツキーの社会構成主義学習理論と、レイヴとウェンガーの「正統的周辺参加論」。社会的相互作用を通じた集合的知識構築プロセス。'
  },

  'law20': {
    name: '価値創造意識',
    description: '経済的・社会的価値を統合的に創出する力。',
    simpleDescription: '会社の利益と社会の幸せを両立させる力。「売上を上げる」だけでなく「社会にとっても良いことをする」という、win-winの発想で事業を考える。美味しくて体に良い食品を作って、お客さんも喜び、会社も繁栄し、環境にも優しいような、三方良しのビジネス創造力です。',
    trizOrigin: '第40原理: 複合材料 / 第28原理: システム代替 - 異なる価値（経済価値と社会価値）を複合材料のように組み合わせ、単一目的のシステムから多目的統合システムへ代替する。',
    psychologyOrigin: 'ポーターとクレーマーの「共通価値創造（CSV）」理論と、社会的起業家精神研究における「ダブル・ボトムライン」思考の心理的基盤。'
  },

  'law21': {
    name: '内発的動機',
    description: '外的報酬に依存しない自律的動機づけ。',
    simpleDescription: '「やらされている」から「やりたい」へと気持ちを変える力。外からの報酬や評価のためではなく、自分自身が心から面白いと感じ、成長を実感できることに動機を見つける。ゲームで攻略本を見ながらクリアするより、自分で謎解きして達成感を味わう方が楽しいような、内側から湧く意欲です。',
    trizOrigin: '第39原理: 不活性雰囲気 / 第21原理: 高速実行 - 外的圧力による不活性状態から脱し、内発的エネルギーによる高速で持続的な行動実行へ。',
    psychologyOrigin: 'デシとライアンの自己決定理論における内発的動機の三要素（自律性、有能感、関係性）と、チクセントミハイのフロー理論における最適経験。'
  },

  'law22': {
    name: '感情知性',
    description: '自己と他者の感情を適切に管理する力。',
    simpleDescription: '自分や相手の感情を「なんとなく」ではなく、きちんと理解して上手に付き合う力。怒りや悲しみも「敵」ではなく「情報」として活用し、感情に振り回されずに適切な行動を選択する。心の天気予報士のように、感情の変化を予測し、最適な対応を取る情緒的知恵です。',
    trizOrigin: '第32原理: 色を変える / 第11原理: 事前保護 - 感情状態を「色」として可視化し、問題が起きる前に適切な感情調整で事前保護を行う。',
    psychologyOrigin: 'ゴールマンの情動知能（EQ）理論と、グロスの感情調整理論。感情の認識、理解、調整、活用という一連の情動的コンピテンシー。'
  },

  'law23': {
    name: 'レジリエンス',
    description: '逆境から回復し成長する力。',
    simpleDescription: '困難にぶつかっても「しなやかに跳ね返る」力。倒れても起き上がり、失敗から学び、逆境を成長の機会に変える。竹のように嵐にしなって折れずに、風が止んだらまた真っ直ぐ立ち上がる。ピンチをチャンスに変える心の筋力です。',
    trizOrigin: '第22原理: 災い転じて福となす / 第37原理: 熱膨張 - 困難という「災い」を成長の「福」に転換し、圧力を受けて拡張する適応的発展。',
    psychologyOrigin: 'アン・マステンの「普通の魔法」としてのレジリエンス概念と、ボナンノの「弾力的回復力」理論。逆境に対する適応的な心理的・生理的反応メカニズム。'
  },

  'law24': {
    name: '自己効力感',
    description: '目標達成への確信を育む力。',
    simpleDescription: '「自分にはできる」という確信を育てる力。小さな成功体験を積み重ねて、だんだん大きな挑戦にも「やってみよう」と思えるようになる。階段を一歩ずつ上るように、自分の能力への信頼を段階的に築き上げる。成功の体験が次の挑戦への勇気になる、ポジティブスパイラルを作る力です。',
    trizOrigin: '第19原理: 周期的作用 / 第12原理: 等ポテンシャル - 成功体験の周期的積み重ねにより、能力への確信を段階的に等しいレベルまで引き上げる。',
    psychologyOrigin: 'バンデューラの自己効力感理論における四つの情報源（遂行行動の達成、代理的経験、言語的説得、情動的・生理的状態）とその統合プロセス。'
  },

  'law25': {
    name: '価値観統合',
    description: '個人的価値観と組織的価値観を調和させる力。',
    simpleDescription: '自分の価値観と会社や社会の価値観を上手に調和させる力。「個人的に大切にしたいこと」と「組織として大切にすべきこと」が矛盾せず、むしろ相乗効果を生むような統合を実現する。自分らしさを保ちながら、チームの一員としても輝ける、価値観のブレンド技術です。',
    trizOrigin: '第8原理: つり合い / 第5原理: 統合 - 個人的価値観と組織的価値観のバランスを保ちながら、より高次の統合された価値体系を構築する。',
    psychologyOrigin: 'シュワルツの価値観理論における価値の普遍的構造と、アイデンティティ発達における統合的達成状態（マーシアのアイデンティティ地位理論）。'
  },

  'law26': {
    name: '使命感',
    description: '仕事に深い意味と目的を見出す力。',
    simpleDescription: '毎日の仕事や人生に「これをやる意味」を見つけ出す力。単なる作業ではなく「誰かの役に立っている」「社会を良くしている」という使命感を持って取り組む。清掃員でも「街を美しくして人々を幸せにする使命」を感じられるような、仕事と人生に深い意味を見出す力です。',
    trizOrigin: '第18原理: 機械的振動 / 第36原理: 相転移 - 単調な作業の繰り返しから、意味ある使命として活動の性質を根本的に転移させる。',
    psychologyOrigin: 'フランクルのロゴセラピーにおける「意味への意志」と、デュフィーとオーレイの仕事の意味理論。実存的意味発見と職業アイデンティティの統合。'
  },

  'law27': {
    name: '精神的安定',
    description: '内面の平静を維持する力。',
    simpleDescription: '心の奥底から湧き上がる静けさと満足感を育てる力。外側の成功や失敗に一喜一憂しすぎず、内面の平静さを保つ。嵐の海でも海底は静かなように、どんな状況でも心の奥に安らぎの場所を持つ。年齢を重ねるほどに深まる、人生の智慧と精神的豊かさです。',
    trizOrigin: '第12原理: 等ポテンシャル / 第39原理: 不活性雰囲気 - 外的変動に左右されない内的安定状態を実現し、精神的不活性雰囲気による平安を獲得する。',
    psychologyOrigin: 'エリクソンの「統合性対絶望」発達課題と、仏教心理学およびマインドフルネス研究における「平静心（equanimity）」の概念。'
  },

  'law28': {
    name: '調和的共存',
    description: '他者・環境との深い調和を実現する力。',
    simpleDescription: '他の人や自然と深くつながり、調和する力。相手の気持ちに寄り添い、環境との一体感を感じ、全体の中での自分の役割を自然に果たす。オーケストラの演奏者が他の楽器の音に耳を澄ませながら美しいハーモニーを創り出すような、共鳴による深い調和の感性です。',
    trizOrigin: '第18原理: 機械的振動 / 第29原理: 流体・気体の利用 - 機械的な関係から、振動による共鳴や流体的な自然な融合による調和へと発展させる。',
    psychologyOrigin: 'カール・ユングの集合的無意識理論と、エコサイコロジーにおける人間と自然の心理的つながり、共感性神経科学における「ミラーニューロン」システム。'
  },

  'law29': {
    name: '超越的視座',
    description: '個人的・時間的制約を超えた視点を獲得する力。',
    simpleDescription: '「自分だけ」「今だけ」の視点を超えて、「みんなで」「長期的に」という広い視野で物事を考える力。鳥になって空から全体を眺めるような俯瞰的視点で、個人的な損得を超えた判断ができる。今日の利益より10年後の社会を考え、自分の会社だけでなく業界全体の発展を願う器の大きさです。',
    trizOrigin: '第17原理: 次元移動 / 第10原理: 先取り作用 - 個人的・短期的な二次元思考から、社会的・長期的な高次元思考へと移動し、未来を先取りした行動を実現する。',
    psychologyOrigin: 'コールバーグの道徳発達における「普遍的倫理」段階と、ウィルバーの意識発達理論における「統合的意識」レベル。自己中心性から世界中心性への発達。'
  },

  'law30': {
    name: '多元的知性',
    description: '認知・感情・身体・直感の知性を統合する力。',
    simpleDescription: '頭で考える・心で感じる・体で実感する・直感で捉える、これら全てを統合して最適な判断を下す力。データ分析、感情的直感、身体的感覚、スピリチュアルな洞察を全て活用する。名医が検査結果、患者の表情、自分の経験、直感を総合して最良の治療法を見つけるような、全人格的な判断能力です。',
    trizOrigin: '第40原理: 複合材料 / 第30原理: 柔軟な膜・薄膜 - 異なる知性の要素を複合材料のように統合し、固定的でない柔軟な判断膜を形成する。',
    psychologyOrigin: 'ガードナーの多重知能理論と、ダマジオの身体化された認知理論。論理-数学的、言語的、身体-運動的、空間的、音楽的、対人的、内省的知能の統合。'
  },

  'law31': {
    name: '心身統合',
    description: '精神と身体の統合的発達を促す力。',
    simpleDescription: '心と体を別々のものとして扱わず、一つのつながったシステムとして成長させる力。運動することで頭もスッキリし、瞑想することで体の調子も良くなる。武道や茶道のように、身体的な練習を通じて精神的な境地に到達する。心身一体の調和的発達を実現する力です。',
    trizOrigin: '第5原理: 統合 / 第31原理: 多孔質材料 - 心と身体という異なる要素を統合し、相互に浸透し合う多孔質的な心身システムを構築する。',
    psychologyOrigin: '身体化された認知理論（embodied cognition）と、ソマティック心理学。身体的経験が認知・感情・行動に与える統合的影響に関する研究。'
  },

  'law32': {
    name: '自動的習慣化',
    description: '成長行動を自動化する力。',
    simpleDescription: '良い習慣を「頑張らなくても自然にできる」レベルまで身につける力。最初は意識的に努力が必要でも、だんだん「歯磨きのように当たり前」になるまで定着させる。川が自然に海に向かって流れるように、成長に向かう行動が自動的に起こるシステムを自分の中に作る力です。',
    trizOrigin: '第25原理: セルフサービス / 第20原理: 連続性の維持 - 外的な強制力に依存せず、内的な自動システムによって継続的な成長行動を維持する。',
    psychologyOrigin: '習慣形成の神経科学的メカニズム（基底核の役割）と、フォッグの行動モデル（動機・能力・トリガーの組み合わせ）における習慣化プロセス。'
  },

  'law33': {
    name: '漸進的変革',
    description: '小さな改善を積み重ねて大きな変化を生む力。',
    simpleDescription: '「一気に大きく変わろう」ではなく、小さな改善を積み重ねて大きな変化を生み出す力。毎日1%ずつ良くなれば、1年後には37倍も成長している。水滴が石を穿つように、小さくても継続的な努力で、やがて質的な大転換を実現する持続的改善の技術です。',
    trizOrigin: '第19原理: 周期的作用 / 第34原理: 廃棄と再生 - 小さな改善サイクルを周期的に実行し、古い方法を廃棄して新しいアプローチを再生させ続ける。',
    psychologyOrigin: 'カイゼンの心理学的基盤と、ロキーチの「小さな変化が大きな変化をもたらす」理論。行動変容における段階的変化プロセス（プロチャスカの変化ステージ理論）。'
  },

  'law34': {
    name: '環境適応',
    description: '変化する環境に柔軟に適応する力。',
    simpleDescription: '変化する環境に合わせて自分を柔軟に調整する力。固い木は嵐で折れるが、しなやかな竹は風に合わせて曲がり生き残る。新しい技術、文化、制度の変化に対して、自分の核となる価値観は保ちながら、方法やアプローチを状況に応じて調整する適応力です。',
    trizOrigin: '第30原理: 柔軟な膜・薄膜 / 第35原理: パラメータ変更 - 固定的構造から柔軟な境界膜へと変更し、環境変化に応じて適切にパラメータを調整する。',
    psychologyOrigin: 'ピアジェの同化と調節のバランス理論と、進化心理学における適応的行動パターン。環境変化に対する認知的・行動的柔軟性のメカニズム。'
  },

  'law35': {
    name: '集合知活用',
    description: 'グループの知恵を最大化する力。',
    simpleDescription: 'チームのみんなの知恵や経験を上手に組み合わせて、一人では思いつかないような素晴らしいアイデアや解決策を生み出す力。パズルのピースが組み合わさって美しい絵になるように、それぞれの人の強みを活かして、チーム全体の能力を最大化する集合的な問題解決能力です。',
    trizOrigin: '第26原理: コピー / 第40原理: 複合材料 - 単純な知識のコピーを超えて、異なる知識・経験を複合材料のように組み合わせた集合的知能を構築する。',
    psychologyOrigin: 'スレッキとホロヤックの「集合知」理論と、ハケットとインホフの「隠れたプロファイル」研究。グループ・ダイナミクスにおける情報統合と創発的問題解決。'
  },

  'law36': {
    name: '持続的発展',
    description: '長期的視点で成長を継続する力。',
    simpleDescription: '「今さえ良ければ」ではなく、10年後、50年後も続く成長を考える力。種を植えて木を育て、その木が森になり、森が次世代に豊かな環境を残すような長期的視点。短期的な利益や楽しさだけでなく、将来にわたって価値を生み続ける持続可能な発展を追求する智恵です。',
    trizOrigin: '第36原理: 相転移 / 第20原理: 連続性の維持 - 短期的成果から長期的価値への相転移を実現し、世代を超えた連続性を維持する持続的発展。',
    psychologyOrigin: 'エリクソンの世代継承性概念と、持続可能性心理学における長期的思考と行動の動機づけメカニズム。未来志向と現在行動の心理的統合。'
  },

  'law37': {
    name: '多面的成長',
    description: '複数の能力を同時に発展させる力。',
    simpleDescription: '一つの分野だけでなく、複数の能力を同時に伸ばしていく力。音楽もスポーツも勉強も、全てが相互に良い影響を与え合って、総合的な人間力を高める。料理人が味覚、視覚、創造性、チームワークなど様々な能力を統合して料理を完成させるような、多面的で統合的な成長能力です。',
    trizOrigin: '第37原理: 熱膨張 / 第7原理: 入れ子 - 一つの能力開発が他の能力領域にも熱膨張的に拡がり、入れ子構造で相互強化する多元的発達。',
    psychologyOrigin: 'ガードナーの多重知能理論と、クロスとパーカーの「スキル転移」研究。異なる能力領域間の相互促進と統合的発達のメカニズム。'
  },

  'law38': {
    name: '誠実性の体現',
    description: '価値観と行動の一貫性を保つ力。',
    simpleDescription: '言っていることと実際の行動が一致している信頼される人になる力。「有言実行」で、約束は必ず守り、価値観に基づいて一貫した行動を取る。表面的でなく、本物の誠実さが内側から自然ににじみ出る。どんな状況でも「あの人らしい」と言われるような、芯の通った人格の一貫性です。',
    trizOrigin: '第38原理: 酸化促進 / 第33原理: 均質性 - 表面的な一致ではなく、内部から外部への酸化的な浸透により、全体的な価値観と行動の均質性を実現する。',
    psychologyOrigin: 'レオン・フェスティンガーの認知的不協和理論と、カール・ロジャーズの「一致（congruence）」概念。自己概念と行動の整合性による心理的健康。'
  },

  'law39': {
    name: '時機把握',
    description: '適切なタイミングで行動を起こす力。',
    simpleDescription: 'チャンスを見逃さず、ベストなタイミングで行動を起こす力。「鉄は熱いうちに打て」のように、物事には最適な時期があることを理解し、その瞬間を逃さずに適切な行動を取る。波乗りで最高の波を見極めて乗るように、人生の機会の波に上手に乗る時機選択の智慧です。',
    trizOrigin: '第21原理: 高速実行 / 第9原理: 先取り反作用 - 機会が現れた瞬間に高速で実行し、タイミングを逸する前に先取り的に行動を起こす。',
    psychologyOrigin: 'カイロス（適切な時）とクロノス（時間の流れ）の心理学的概念と、直観的意思決定理論における「thin-slicing」（瞬間的判断）能力。'
  },

  'law40': {
    name: '永続的向上心',
    description: '生涯を通じて成長し続ける力。',
    simpleDescription: '「もう十分」「これで完成」と思わず、いつまでも学び続け、成長し続ける力。年齢に関係なく新しいことに挑戦し、昨日の自分より今日の自分、今日の自分より明日の自分を向上させ続ける。富士山のように、どこまで登っても更に高い頂があることを知っている、終わりなき向上心です。',
    trizOrigin: '第40原理: 複合材料 / 第15原理: ダイナミック化 - 既存の能力や知識を基盤材料として、常に新しい要素を複合化し、固定的でない動的な成長システムを構築する。',
    psychologyOrigin: 'キャロル・ドゥエックの「成長マインドセット」理論と、生涯発達心理学における「可塑性（plasticity）」概念。年齢に関係なく継続する学習と適応の能力。'
  }
};

// ==========================================
// レーダーチャート軸定義（8軸）
// ==========================================

export const radarAxes = [
  {
    key: 'integrationThinking',
    name: '統合思考力',
    description: '複数の視点を統合し、全体最適を実現する思考力',
    relatedLaws: ['law01', 'law04', 'law30'],
    color: '#6366f1'
  },
  {
    key: 'adaptiveDevelopment',
    name: '適応発達力',
    description: '環境変化に柔軟に適応し、継続的に成長する力',
    relatedLaws: ['law07', 'law34', 'law39'],
    color: '#8b5cf6'
  },
  {
    key: 'reflection',
    name: '振り返り力',
    description: '自己の行動・思考を客観視し、改善につなげる力',
    relatedLaws: ['law03', 'law08', 'law33'],
    color: '#ec4899'
  },
  {
    key: 'balance',
    name: 'バランス力',
    description: '異なる要素を調和させ、最適なバランスを実現する力',
    relatedLaws: ['law09', 'law17', 'law28'],
    color: '#f43f5e'
  },
  {
    key: 'innovation',
    name: 'イノベーション力',
    description: '創造的な発想で新しい価値を生み出す力',
    relatedLaws: ['law05', 'law19', 'law20'],
    color: '#f97316'
  },
  {
    key: 'empathy',
    name: '共感力',
    description: '他者の感情や視点を理解し、深いつながりを築く力',
    relatedLaws: ['law11', 'law13', 'law22'],
    color: '#eab308'
  },
  {
    key: 'collaboration',
    name: '協働力',
    description: 'チームで協力し、集合的な成果を最大化する力',
    relatedLaws: ['law12', 'law35', 'law18'],
    color: '#22c55e'
  },
  {
    key: 'initiative',
    name: '主体性',
    description: '自ら目標を設定し、主体的に行動を起こす力',
    relatedLaws: ['law21', 'law24', 'law40'],
    color: '#14b8a6'
  }
];

// ==========================================
// ヘルパー関数
// ==========================================

/**
 * 法則IDから法則データを取得
 * @param {string} lawId - 法則ID (例: 'law01')
 * @returns {Object|null} 法則データ
 */
export const getLawById = (lawId) => {
  return developmentLaws[lawId] || null;
};

/**
 * 法則番号（1-40）から法則データを取得
 * @param {number} lawNumber - 法則番号 (1-40)
 * @returns {Object|null} 法則データ
 */
export const getLawByNumber = (lawNumber) => {
  const lawId = `law${String(lawNumber).padStart(2, '0')}`;
  return getLawById(lawId);
};

/**
 * 全法則を配列形式で取得
 * @returns {Array} 法則データの配列
 */
export const getAllLaws = () => {
  return Object.entries(developmentLaws).map(([id, data]) => ({
    id,
    number: parseInt(id.replace('law', ''), 10),
    ...data
  }));
};

/**
 * 特定のレーダー軸に関連する法則を取得
 * @param {string} axisKey - 軸のキー (例: 'integrationThinking')
 * @returns {Array} 関連する法則データの配列
 */
export const getLawsByAxis = (axisKey) => {
  const axis = radarAxes.find(a => a.key === axisKey);
  if (!axis) return [];

  return axis.relatedLaws.map(lawId => ({
    id: lawId,
    ...developmentLaws[lawId]
  }));
};

/**
 * Freeプランで閲覧可能な法則（最初の10個）を取得
 * @returns {Array} 法則データの配列
 */
export const getFreePlanLaws = () => {
  return getAllLaws().slice(0, 10);
};

/**
 * 有料プラン限定の法則（11-40）を取得
 * @returns {Array} 法則データの配列
 */
export const getPremiumLaws = () => {
  return getAllLaws().slice(10);
};

/**
 * キーワード検索で法則を取得
 * @param {string} keyword - 検索キーワード
 * @returns {Array} マッチした法則データの配列
 */
export const searchLaws = (keyword) => {
  if (!keyword) return getAllLaws();

  const lowerKeyword = keyword.toLowerCase();
  return getAllLaws().filter(law =>
    law.name.toLowerCase().includes(lowerKeyword) ||
    law.description.toLowerCase().includes(lowerKeyword) ||
    (law.simpleDescription && law.simpleDescription.toLowerCase().includes(lowerKeyword))
  );
};

// ==========================================
// デフォルトエクスポート
// ==========================================

export default {
  developmentLaws,
  radarAxes,
  getLawById,
  getLawByNumber,
  getAllLaws,
  getLawsByAxis,
  getFreePlanLaws,
  getPremiumLaws,
  searchLaws
};